import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadpartytokenComponent } from './uploadpartytoken/uploadpartytoken.component';
import { CommonuploadimagemodelComponent } from '../shared/commonuploadimagemodel/commonuploadimagemodel.component';
import { PlayersCharacterListComponent } from './players-character-list/players-character-list.component';
import { ip, WORLD_TUMBLER_URL } from 'src/app/constant/constant';
import { DataService } from 'src/app/services/data.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { GameDetailsModalComponent } from './game-details-modal/game-details-modal.component';
import { CreateGameMapSelectionModalComponent } from './creategame/create-game-map-selection-modal/create-game-map-selection-modal.component';
import { SubscriptionStatus } from '../subscription/models/subscription-usage.model';
import { ActivatedRoute } from '@angular/router';
import { ViewportService } from 'src/app/services/viewport.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-active-games',
  templateUrl: './active-games.component.html',
  styleUrls: ['./active-games.component.scss'],
  standalone: false
})
export class ActiveGamesComponent implements OnInit, OnDestroy {
  gamelistdata: any;
  imageurl = ip;
  user_id: any;
  currentDate: string;
  map_id: any;
  disablebtn: boolean = false;
  pendinginvitationlist: any;
  activePath: string;

  isClassAdded = false;
  planUsage: SubscriptionStatus | null = null;
  selectedTab: 'active' | 'paused' | 'completed' = 'active';
  viewMode: 'cards' | 'rows' = 'cards';
  isMobile = false;
  /** The choice made on a wide screen, restored when leaving mobile widths. */
  private preferredViewMode: 'cards' | 'rows' = 'cards';
  private viewportSubscription: Subscription;

  setViewMode(mode: 'cards' | 'rows') {
    this.preferredViewMode = mode;
    this.viewMode = mode;
  }

  get gamesForTab(): any[] {
    return this.selectedTab === 'active' ? this.gamelistdata || [] : [];
  }

  /** status pill for a game: needs-map / unseated / seats-open / ready */
  gameStatus(game: any): string {
    if (this.selectedTab !== 'active') return this.selectedTab;
    if (game?.map_id === undefined || game?.map_id === null) return 'needs-map';
    if (this.filledSeats(game).length === 0) return 'unseated';
    return this.openSeats(game) > 0 ? 'seats-open' : 'ready';
  }

  gameStatusLabel(game: any): string {
    return (
      {
        'needs-map': 'Needs a map',
        unseated: 'No players yet',
        'seats-open': 'Seats open',
        ready: 'Party full',
        paused: 'Paused',
        completed: 'Completed',
      } as Record<string, string>
    )[this.gameStatus(game)];
  }

  filledSeats(game: any): any[] {
    return (game?.active_characters || []).filter((c: any) => c?.character_id);
  }

  // every party has 8 seats (the start window and game details show 8);
  // the games list only sends the seated characters
  openSeats(game: any): number {
    return Math.max(0, 8 - this.filledSeats(game).length);
  }

  initials(c: any): string {
    const n = c?.nickname || c?.user_name || '?';
    return n.trim().slice(0, 2).toUpperCase();
  }

  partyNames(game: any): string {
    const names = this.filledSeats(game).map((c: any) => (c.nickname || c.user_name || '').split(' ')[0]).filter(Boolean);
    if (!names.length) return 'No players seated';
    const open = this.openSeats(game);
    return names.join(', ') + (open ? ` · ${open} seat${open > 1 ? 's' : ''} open` : '');
  }

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private dataserv: DataService,
    private currentUserService: CurrentUserService,
    private activatedRoute: ActivatedRoute,
    private viewport: ViewportService,
    private cdr: ChangeDetectorRef,
  ) {
    this.isClassAdded = true;
  }

  ngOnInit(): void {
    this.viewportSubscription = this.viewport.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
      this.viewMode = isMobile ? 'cards' : this.preferredViewMode;
      this.cdr.detectChanges();
    });
    this.activePath = localStorage.getItem('activePath');
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = data.id;
        if (this.user_id) {
          this.disablebtn = false;
        } else {
          this.disablebtn = true;
        }
        this.getactivegamelist();
        this.configureActivatedRoute();
        this.cdr.detectChanges();
      }
    });
    this.currentUserService.planUsageData.subscribe(
      (data: SubscriptionStatus) => {
        if (data) {
          this.planUsage = data;
          this.cdr.detectChanges();
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.viewportSubscription?.unsubscribe();
  }

  private configureActivatedRoute() {
    this.activatedRoute.queryParams.subscribe((params) => {
      const tab = params['tab'];
      if (tab === 'createModal') {
        this.newgame();
      }
      this.cdr.detectChanges();
    });
  }

  openWikiPage() {
    window.open(
      WORLD_TUMBLER_URL + '/wiki/index.php/Player_Creation_Guide',
      '_blank',
    );
  }

  newgame() {
    if (this.user_id) {
      this.modalService.open(
        CreateGameMapSelectionModalComponent,
        {
          size: 'sm',
          backdrop: 'static',
          centered: true,
        },
      );
    } else {
      this.router.navigate(['/login']);
    }
  }

  isGameCreateDisabled() {
    const feature = this.planUsage.subscription_features;
    const usage = this.planUsage.usage;

    if (feature.max_games_created === -1) return false;

    return usage.games_created >= feature.max_games_created;
  }

  shouldShowGameLimitReached(): boolean {
    if (!this.planUsage) return false;

    const feature = this.planUsage.subscription_features;
    const usage = this.planUsage.usage;

    if (feature.max_games_created === -1) return false;

    return usage.games_created >= feature.max_games_created;
  }

  imguploadopenmodel(data: any) {
    const addmodalRef = this.modalService.open(
      CommonuploadimagemodelComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      },
    );
    addmodalRef.componentInstance.masterUpdate = data.id;
    addmodalRef.componentInstance.selectedImage = ip + data.image;
    addmodalRef.result.then((res) => {
      if (res) {
        this.getactivegamelist();
      }
      this.cdr.detectChanges();
    });
  }

  uploadFile(data: any) {
    const addmodalRef = this.modalService.open(UploadpartytokenComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    addmodalRef.componentInstance.masterUpdate = data.id;
    addmodalRef.componentInstance.selectedImage = ip + data.image;
    addmodalRef.result.then((res) => {
      if (res) {
        this.getactivegamelist();
      }
      this.cdr.detectChanges();
    });
  }

  gotogamedetail(game_id: Number) {
    this.router.navigate(['/game-master-detail/' + game_id + '/']);
  }

  goBack() {
    this.router.navigate(['/activegames']);
  }

  getactivegamelist() {
    this.gamelistdata = [];
    this.dataserv.getactivegames(this.user_id).subscribe((data: any) => {
      this.gamelistdata = data?.gamemasterdetails || [];
      this.cdr.detectChanges();
    });
  }

  playgame(gamedetail: any) {
    this.map_id = gamedetail.map_id;
    const today = new Date();
    this.currentDate = today.toISOString().slice(0, 10);
    const modalRef = this.modalService.open(GameDetailsModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.map_id = gamedetail.map_id;
    modalRef.componentInstance.game_id = gamedetail.id;
    modalRef.componentInstance.partyTokenUrl = gamedetail.partytoken;

    modalRef.componentInstance.game_details = gamedetail;
    modalRef.componentInstance.activePlayers = gamedetail.active_players;
  }

  playercharacterlist(id) {
    const addmodalRef = this.modalService.open(PlayersCharacterListComponent, {
      size: 'xl',
      backdrop: 'static',
      centered: true,
    });
    addmodalRef.componentInstance.id = id;
  }

  deleteGame(id) {
    this.dataserv.deleteGame(id).subscribe((data: any) => {
      if (data) {
        this.getactivegamelist();
      }
      this.cdr.detectChanges();
    });
  }
}
